/**
 * PhoenixBrandEngagementForm
 *
 * A web component to wrap a <form> element that has a single text input,
 * which is assumed to be the first <input> element within the form.
 * When the form is submitted, the name and value of the input are POSTed
 * as a JSON object to the URL specified in the submit-url attribute. If
 * the request succeeds, the success-message attribute replaces the input;
 * if it fails, the error-message is shown.
 *
 * Sample markup:
 *
 *   <phoenix-brand-engagement-form
 *     action="/.api/add-email-to-mailing-list"
 *     success-message="Thank you!"
 *     error-message="An error occurred.">
 *     <form>
 *       <input name="email">
 *       <input type="submit">
 *     </form>
 *   </phoenix-brand-engagement-form>
 *
 */
'use strict';

var basicAuth = require('../../lib/basicAuth');
const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:brandEngagementForm');

class PhoenixBrandEngagementForm extends HTMLElement {
    connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input.m-brand-engagement--main-input');
        this.action = this.getAttribute('action');

        var self = this;
        this.submitListener = function (evt) {
            evt.preventDefault();

            if (!self.input.value || self.input.value === '') {
                self.showError();
                return;
            }

            var opts = basicAuth.getRequestOptions();
            opts.method = 'POST';
            if (!opts.headers) {
                opts.headers = {};
            }
            opts.headers['Content-Type'] = 'application/json';

            if (!self.action || !self.input.getAttribute('name')) {
                // eslint-disable-next-line no-console
                console.error('Form not properly configured with form action and input name');
                self.showError();
                return;
            }
            var body = {};
            this.querySelectorAll('input').forEach((i) => {
                if (i.getAttribute('name')) {
                    body[i.getAttribute('name')] = i.value;
                }
            });

            opts.body = JSON.stringify(body);

            fetch(self.action, opts)
                .then(function (response) {
                    if (response.ok) {
                        if (typeof window !== 'undefined') {
                            const dataLayer = window.dataLayer || [];
                            const href = window.location && window.location.href;
                            window.dataLayer = dataLayer;
                            const evt = {
                                event: 'brand-engagement-signup',
                                page: href,
                                productItemId: body.productItemId,
                                type: 'brand-engagement',
                            };
                            dataLayer.push(evt);
                        }
                        self.showSuccess();
                    } else {
                        self.showError();
                    }
                })
                .catch(function () {
                    self.showError();
                });
        };
        this.form.addEventListener('submit', this.submitListener);
    }

    disconnectedCallback() {
        this.form.removeEventListener('submit', this.submitListener);
    }

    showMessage(msg) {
        this.input.blur();
        this.input.value = '';
        this.input.setAttribute('placeholder', msg);
    }

    showError() {
        this.input.classList.add('is-error');
        this.showMessage(this.getAttribute('error-message'));
    }

    showSuccess() {
        this.input.classList.remove('is-error');
        this.showMessage(this.getAttribute('success-message'));
    }
}

window.customElements.define('phoenix-brand-engagement-form', PhoenixBrandEngagementForm);
measure.end();
